export const findDivsByIds = (ids: string[]) => {
  return ids.map(id => document.getElementById(id)).filter(Boolean);
};

export const getKeywordsFromDiv = (div: HTMLElement) => {
  return div.getAttribute('keywords') || div.getAttribute('data-keywords') || '';
};
